export type Platform = 'ios' | 'android' | 'desktop';

/** The parts of `navigator` the guess needs, so it can be tested without a browser. */
export interface NavigatorLike {
  readonly userAgent: string;
  readonly maxTouchPoints?: number;
}

/**
 * Where a download ends up and how to reach it depends on the phone, not the
 * browser: every iOS browser saves into the Files app, Android into Downloads.
 * iPadOS asks for desktop pages and reports itself as a Mac, so a touch screen
 * "Mac" is an iPad.
 */
export function detectPlatform(nav: NavigatorLike | undefined = globalThis.navigator): Platform {
  if (!nav) return 'desktop';
  const ua = nav.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  if (/macintosh/i.test(ua) && (nav.maxTouchPoints ?? 0) > 1) return 'ios';
  return 'desktop';
}

/**
 * A link that opens the folder downloads go to, where the system allows one:
 * the Files app on iOS, the Downloads app on Android (Chrome follows `intent:`
 * links on a tap). Desktop browsers show their own download list.
 */
export function savedFilesLink(platform: Platform): string | null {
  switch (platform) {
    case 'ios':
      return 'shareddocuments://';
    case 'android':
      return 'intent:#Intent;action=android.intent.action.VIEW_DOWNLOADS;end';
    default:
      return null;
  }
}
